"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dormantMember = void 0;
var qs = require('qs');
exports.dormantMember = function (axios) {
    return {
        // [DormantMember]
        getDormantMembers: function (getDormantMembersRequest) {
            return axios.get('/dormant-members', getDormantMembersRequest);
        },
        putDormantMembers: function (_a) {
            var params = _a.params;
            return axios.put("/dormant-members?" + qs.stringify(params, { arrayFormat: 'comma' }));
        },
        deleteDormantMembers: function (request) {
            return axios.delete('/dormant-members', request);
        }
    };
};
